class WlPhotoCarousel {
  constructor(root) {
    this.track = root.querySelector('.wl-photo-carousel__track');
    this.items = Array.from(root.querySelectorAll('.wl-photo-carousel__item'));

    if (!this.track || !this.items.length) return;

    this.activeIndex = -1;
    this.pendingFrame = false;

    this.track.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
    window.addEventListener('resize', this.onScroll.bind(this), { passive: true });

    this.syncActive();
    this.centreInitial();

    // Images settling can change the measurements the active slide is picked
    // from, so take one more reading once everything has loaded.
    window.addEventListener('load', () => this.syncActive(true), { once: true });
  }

  // Open on the second slide, so a slide peeks on both sides rather than the
  // first sitting flush against the left edge with empty space beside it.
  centreInitial() {
    if (this.items.length < 3) return;
    // Desktop lays the photos out as a static grid -- nothing to scroll.
    if (getComputedStyle(this.track).overflowX !== 'auto') return;

    // Two frames: the first lets layout settle, the second runs after the
    // browser has done its own initial snap, which would otherwise undo this.
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const item = this.items[1];
        if (!item) return;

        const behavior = this.track.style.scrollBehavior;
        const snap = this.track.style.scrollSnapType;
        // scroll-snap-type: x mandatory re-snaps a programmatic scroll on the
        // spot, and scroll-behavior: smooth would animate it on page load.
        this.track.style.scrollSnapType = 'none';
        this.track.style.scrollBehavior = 'auto';
        this.track.scrollLeft += this.offsetFromCentre(item);

        requestAnimationFrame(() => {
          // Restored a frame later so snapping resumes from the new position
          // rather than pulling straight back to the first slide.
          this.track.style.scrollSnapType = snap;
          this.track.style.scrollBehavior = behavior;
          this.syncActive(true);
        });
      });
    });
  }

  onScroll() {
    if (this.pendingFrame) return;
    this.pendingFrame = true;
    requestAnimationFrame(() => {
      this.pendingFrame = false;
      this.syncActive();
    });
  }

  // Distance from a slide's centre to the track's centre. Uses rects rather
  // than offsets so the CSS scale on inactive slides doesn't skew the maths
  // (scaling is centre-origin, so centres stay put).
  offsetFromCentre(item) {
    const track = this.track.getBoundingClientRect();
    const rect = item.getBoundingClientRect();
    return rect.left + rect.width / 2 - (track.left + track.width / 2);
  }

  // The slide sitting closest to the centre is the active one. `force` skips
  // the no-change guard, for the cases where the class may have been applied
  // from a stale measurement.
  syncActive(force) {
    let index = 0;
    let closest = Infinity;

    this.items.forEach((item, i) => {
      const distance = Math.abs(this.offsetFromCentre(item));
      if (distance < closest) {
        closest = distance;
        index = i;
      }
    });

    if (index === this.activeIndex && !force) return;
    this.activeIndex = index;

    this.items.forEach((item, i) => item.classList.toggle('is-active', i === index));
  }
}

function initPhotoCarousels() {
  document.querySelectorAll('[data-wl-photo-carousel]').forEach((root) => {
    if (root.dataset.wlCarouselReady) return;
    root.dataset.wlCarouselReady = 'true';
    new WlPhotoCarousel(root);
  });
}

initPhotoCarousels();
document.addEventListener('shopify:section:load', initPhotoCarousels);
